<h2 mat-dialog-title style="color: #0061A2">
    {{title}}
</h2>
<form [formGroup]="newVisit" fxLayout="column" style="width: 100%; margin: 20px 0px;" (ngSubmit)="onConfirm()"
    autocomplete="off">
    <div mat-dialog-content fxLayout="column">
        <div fxFlex="100">
            <div fxFlex="49.4" fxFlex.sm='100' fxFlex.xs='100'>
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Fecha:</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="date">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>
            <div fxFlex="49.4" fxFlex.sm='100' fxFlex.xs='100' *ngIf='!isEditable'>
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Relacionado a</mat-label>
                    <input matInput placeholder="Relacionado a" formControlName="typeClient">
                </mat-form-field>
            </div>
        </div>
        <div fxFlex="100">
            <mat-form-field appearance="outline" style="width: 99%;">
                <mat-label>Nombre Contacto</mat-label>
                <mat-select formControlName="contactIds" multiple>
                    <mat-option *ngFor="let nameContactVisit of contactList" [value]="nameContactVisit.id">
                        {{nameContactVisit.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxFlex="100">
            <mat-form-field appearance="outline" style="width: 99%;">
                <mat-label>Acompañante</mat-label>
                <mat-select formControlName="partner">
                    <mat-option *ngFor="let namePartner of partnerList" [value]="namePartner.id">
                        {{namePartner.first_name + ' ' + namePartner.last_name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxFlex="100" fxLayout='row' fxLayout.sm='column' fxLayout.xs='column'>
            <div fxFlex="49.4" fxFlex.sm='100' fxFlex.xs='100'>
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Jornada</mat-label>
                    <mat-select formControlName="time">
                        <mat-option *ngFor="let timeDayVisit of timeDayList" [value]="timeDayVisit.id">
                            {{timeDayVisit.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxFlex="49.4" fxFlex.sm='100' fxFlex.xs='100'>
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Tipo de Contacto</mat-label>
                    <mat-select formControlName="type">
                        <mat-option *ngFor="let typeVisit of typeContactList" [value]="typeVisit.id">
                            {{typeVisit.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div fxFlex="100">
            <mat-form-field appearance="outline" style="width: 99%;">
                <mat-label>Resumen de la Visita</mat-label>
                <textarea matInput placeholder="Resumen de la Visita" formControlName="summary"></textarea>
            </mat-form-field>
        </div>
        <div fxFlex="100" *ngIf="showVisitPdf" class="visit-pdf-wrap">
            <div fxFlex="100" class="visit-pdf-field">
                <input #visitPdfInput type="file" accept=".pdf,application/pdf" (change)="onVisitPdfChange($event)" style="display: none">
                <ng-container *ngIf="!visitPdfUrl">
                    <span class="visit-pdf-label">Archivo PDF (cotización)</span>
                    <div class="visit-pdf-row">
                        <button mat-flat-button color="primary" type="button" (click)="triggerVisitPdfInput()" class="visit-pdf-btn">
                            <mat-icon>upload_file</mat-icon>
                            {{ newVisit.controls['visitPdf'].value ? 'Reemplazar archivo' : 'Seleccionar archivo' }}
                        </button>
                        <span class="visit-pdf-filename" *ngIf="newVisit.controls['visitPdf'].value">{{ newVisit.controls['visitPdf'].value?.name }}</span>
                    </div>
                    <span class="visit-pdf-hint">Solo archivos PDF</span>
                    <p class="visit-pdf-error" *ngIf="newVisit.controls['visitPdf'].hasError('required') && formSubmitted">
                        El archivo PDF es obligatorio cuando el tipo de contacto es Correo Electrónico (Cotización).
                    </p>
                </ng-container>
                <div class="visit-pdf-download" *ngIf="visitPdfUrl">
                    <span class="visit-pdf-download-label">Documento adjunto</span>
                    <button type="button" class="visit-pdf-download-btn" mat-stroked-button color="primary" (click)="onDownloadVisitPdf()">
                        <mat-icon>get_app</mat-icon>
                        Descargar PDF
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions fxLayoutAlign="end none">
        <button mat-button type="button" (click)="onDismiss()">Cerrar</button>
        <!-- <button *ngIf='!isEditable' mat-raised-button color="primary" type="submit">Borrar</button> -->
        <button *ngIf='isEditable' mat-raised-button color="primary" type="submit">Guardar</button>
    </div>
</form>